export default class GameCategoryData {

  constructor (data) {
    this.data = data
  }
}